<script lang="ts" setup>
import type { HTMLAttributes } from 'vue';
import { reactiveOmit } from '@vueuse/core';
import { CalendarCellTrigger, type CalendarCellTriggerProps, useForwardProps } from 'reka-ui';
import { cn } from '@/lib/utils';
import { buttonVariants } from '@/components/ui/button';

const props = defineProps<CalendarCellTriggerProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <CalendarCellTrigger
    :class="
      cn(
        buttonVariants({ variant: 'ghost' }),
        'tw-h-8 tw-w-8 tw-p-0 tw-font-normal',
        '[&[data-today]:not([data-selected])]:tw-bg-secondary-100 [&[data-today]:not([data-selected])]:tw-text-secondary-900 dark:[&[data-today]:not([data-selected])]:tw-bg-secondary-800 dark:[&[data-today]:not([data-selected])]:tw-text-secondary-50',
        // Selected
        'data-[selected]:tw-bg-secondary-600 data-[selected]:tw-text-surface-0 data-[selected]:tw-opacity-100 data-[selected]:hover:tw-bg-secondary-700 data-[selected]:hover:tw-text-surface-0 data-[selected]:focus:tw-bg-secondary-700 data-[selected]:focus:tw-text-surface-0 dark:data-[selected]:tw-bg-secondary-500 dark:data-[selected]:tw-text-surface-0 dark:data-[selected]:hover:tw-bg-secondary-600 dark:data-[selected]:hover:tw-text-surface-0 dark:data-[selected]:focus:tw-bg-secondary-600 dark:data-[selected]:focus:tw-text-surface-0',
        // Disabled
        'data-[disabled]:tw-text-secondary-500 data-[disabled]:tw-opacity-50 dark:data-[disabled]:tw-text-secondary-400',
        // Unavailable
        'data-[unavailable]:tw-text-secondary-50 data-[unavailable]:tw-line-through dark:data-[unavailable]:tw-text-secondary-50',
        // Outside months
        'data-[outside-view]:tw-text-secondary-500 data-[outside-view]:tw-opacity-50 [&[data-outside-view][data-selected]]:tw-bg-secondary-100/50 [&[data-outside-view][data-selected]]:tw-text-secondary-500 [&[data-outside-view][data-selected]]:tw-opacity-30 dark:data-[outside-view]:tw-text-secondary-400 dark:[&[data-outside-view][data-selected]]:tw-bg-secondary-800/50 dark:[&[data-outside-view][data-selected]]:tw-text-secondary-400',
        props.class
      )
    "
    v-bind="forwardedProps"
  >
    <slot />
  </CalendarCellTrigger>
</template>
